import React from "react";
import { AiOutlineClockCircle } from "react-icons/ai";

const PendingSellers = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[400px] bg-white rounded-lg shadow-sm p-8">
      <AiOutlineClockCircle size={64} className="text-gray-300 mb-4" />
      <h2 className="text-xl font-semibold text-gray-700 mb-2">
        Pending Seller Approvals
      </h2>
      <p className="text-gray-500 text-center max-w-md">
        The seller approval feature is currently not available. This section
        will show seller accounts awaiting approval.
      </p>
    </div>
  );
};

export default PendingSellers;
